import {
  useCallback, useContext, useState
} from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { ErrorMessage, Input } from '../components';
import { AuthUserContext } from '../components/auth-component';
import { Button } from '../components/basic-inputs/button';
import { AfterLife } from '../components/logo';
import { useSignup } from '../hooks';

export function SignUpPage() {
  const navigate = useNavigate();
  const [ error, setError ] = useState('');

  const { handleSignup } = useSignup();
  const { setUser } = useContext(AuthUserContext);

  const handleClick = useCallback(
    async (event) => {
      console.log(event);
      event.preventDefault();
      const form = event.target.form;
      const data = new FormData(form);

      const payload = {
        email: data.get('email'),
        password: data.get('password'),
        firstName: data.get('first-name'),
        lastName: data.get('last-name')
      };

      if (!payload.email) {
        return setError('Email is required');
      }

      if (!payload.password) {
        return setError('Password is required');
      }

      if (payload.password !== data.get('confirm-password')) {
        return setError('Passwords do not match');
      }

      try {
        const json = await handleSignup(payload);

        if (json) {
          setUser(json);
          return navigate('/signup/profile');
        }
      } catch (error) {
        console.error('Error signing up', error);
        setError('Error signing up');
      }
    },
    [ handleSignup, navigate, setUser ]
  );

  // TODO: fix import exports
  // TODO: move logic to a component
  return (
    <div className="signup-page">
      <Link to="/" className="auth-page-header">
        <AfterLife />
      </Link>
      <h2 className="subheader">Sign up to start - for today and tomorrow</h2>
      <p className="error">{error}</p>
      <form>
        <Input id="email" label="Email" required  autoCapitalize="off"/>
        <Input id="password" label="Password" required  autoCapitalize="off"/>
        <Input id="confirm-password" label="Confirm Password" required  autoCapitalize="off"/>
        <p>*Required</p>
        <ErrorMessage message={error} />
        <Button fullWidth onClick={handleClick}>
          Create Account
        </Button>
      </form>
      <p className="footer">
        Already have an account? <Link to="/login">Log in!</Link>
      </p>
    </div>
  );
}
